import { FC } from 'react';

import Col from 'antd/es/col';

import { TypeOfPropsFor } from '@utils/types';

const responsive = {
  xs: 24,
  sm: 24,
  md: 12,
};

const responsiveReset = {
  xs: undefined,
  sm: undefined,
  md: undefined,
};
export const BaseCol: FC<
  TypeOfPropsFor<typeof Col> & { resetResponsive?: boolean }
> = (props) => (
  <Col {...(props.resetResponsive ? responsiveReset : responsive)} {...props} />
);

export default BaseCol;
